import React from 'react';
import assign from 'object-assign';
// components
import IconButton from 'material-ui/IconButton';

import Form from '../Common/Form.react';
import TextField from '../Common/TextField';
import CancelIcon from 'material-ui/svg-icons/navigation/cancel';
import { Card, CardText } from 'material-ui/Card';

import ContactActions from '../../actions/ContactActionCreator';
import ContactStore from '../../stores/ContactStore';

const phoneRegex = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im;
const emailRegex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;

const ContactForm = React.createClass({

    getInitialState: function () {

        return {

            isEdit: (this.props.routeParams.id !== undefined && !!this.props.routeParams.id.match(/\d+/)),

            form: {
                email: '',
                phone: null
            },
            details: {
                id: '',
                name: '',
                email: '',
                phoneNumbers: [],
                notes: ''
            }
        };
    },

    componentDidMount: function() {
        if(this.state.isEdit) {
            ContactStore.addChangeListener(this._onChange);
            ContactActions.getById(this.props.routeParams.id);
        }
    },

    componentWillUnmount: function() {
        if (this.state.isEdit) {
            ContactStore.removeChangeListener(this._onChange);
        }
    },

    _onSave: function (model) {
        model.phoneNumbers = this.state.details.phoneNumbers;

        if(!this.state.isEdit) {
            return ContactActions.save(model);
        } else {
            return ContactActions.update(this.props.routeParams.id, model);
        }
    },

    render: function () {
        let formTitle = (!this.state.isEdit ? 'New' : 'Edit');
        let self = this;

        return(
            <Form title={formTitle}
                onSave={this._onSave}
                redirectTo="/dashboard/contacts"
            >
                <Card className="cent-card">
                    <CardText>
                        <TextField
                            name="name"
                            value={this.state.details.name}
                            validations="minLength:2,maxLength:255"
                            validationError="Please use only letters, at least 2"
                            hintText="Name"
                            floatingLabelText="Name"
                            required
                        />
                        <TextField
                            name="email"
                            value={this.state.details.email}
                            validations="isEmail"
                            validationError="Please enter a valid email address"
                            hintText="Email"
                            floatingLabelText="Email"
                        />
                        <TextField
                            name="phoneNumbers"
                            value={this.state.form.phone}
                            validations={{ matchRegexp: phoneRegex }}
                            validationError="Please enter a valid phone number"
                            hintText="Tel."
                            floatingLabelText="Tel."
                            onEnterKeyDown={this._onPhoneAdd}
                        />
                        <div>
                            <ul className="pills">
                            {this.state.details.phoneNumbers.map(function(phone, i) {
                                var phoneNumber = (typeof phone === 'string') ? phone : phone.number;
                                return (
                                    <span key={i}>
                                        <li>{phoneNumber}
                                            <IconButton
                                                iconStyle={{height: "16px", width: "16px"}}
                                                style={{height: "16px", width: "16px", padding: "2px"}}
                                                tooltip="delete"
                                                onClick={self._onPhoneRemove.bind(self, phone)}
                                            >
                                                <CancelIcon  />
                                            </IconButton>
                                        </li>
                                    </span>

                                )
                            })}
                            </ul>
                        </div>
                        <TextField
                            name="notes"
                            value={this.state.details.notes}
                            multiLine={true}
                            hintText="Notes"
                            floatingLabelText="Notes"
                        />
                    </CardText>
                </Card>
            </Form>
        );
    },

    _onChange: function() {
        let contact = ContactStore.getById(this.props.routeParams.id);
        if (contact !== undefined) {
            if (!!contact.phoneNumbers) {
                contact.phoneNumbers = contact.phoneNumbers.map(function(phone) {
                    return phone.number;
                });
            } else {
                contact.phoneNumbers = [];
            }
            const state = assign(this.state, {details: contact});
            this.setState(state);
        }
    },

    _onPhoneAdd: function(event) {
        const phoneNumber = event.target.value;
        const isValid = phoneNumber.match(phoneRegex);
        if (!isValid) {
             return false;
        }
        let state = this.state;
        if(state.details.phoneNumbers.indexOf(phoneNumber) === -1) {
            state.details.phoneNumbers.push(phoneNumber);
        }
        state.form.phone = '';
        this.setState(state);
    },

    _onPhoneRemove: function(phoneNumber) {
        let state = this.state;
        let i = state.details.phoneNumbers.indexOf(phoneNumber);
        delete state.details.phoneNumbers[i];

        this.setState(state);
    }
});

export default ContactForm;
